import React from 'react'
import { Network, BadgeCheck } from 'lucide-react'

const TYPE_TONE = {
  Acquisition: 'var(--onds-bull)',
  Merger: 'var(--onds-bull)',
  Subsidiary: 'var(--onds-accent)',
  Investment: 'var(--onds-caution)',
  Partnership: '#a78bfa',
  Agreement: '#38bdf8',
}

const typeColor = (type) => TYPE_TONE[type] ?? 'var(--onds-text-dim)'

const BATTERY_TONE = {
  Platform: 'var(--onds-accent)',
  Customer: 'var(--onds-bull)',
  Plant: 'var(--onds-caution)',
  Program: '#7dffd4',
}

export default function HoldingsPanel({ holdings, battery = false }) {
  if (!holdings?.length) return null

  return (
    <div className="onds-card p-5 md:p-6">
      <div className="flex items-center gap-2 mb-1">
        <Network className="h-5 w-5" style={{ color: 'var(--onds-accent)' }} />
        <h2 className="text-lg font-bold">{battery ? 'Cells, Customers & Plants' : 'What Ondas Is Building'}</h2>
        <span className="text-sm text-[var(--onds-text-dim)]">{battery ? 'SiCore · SiMaxx · design wins' : 'holdings · acquisitions · agreements'}</span>
      </div>
      <p className="text-xs text-[var(--onds-text-dim)] mb-4">
        {battery
          ? 'Amprius is a battery manufacturer — silicon-anode platforms, the plants that build them, and the customers that fly them.'
          : 'Ondas is a holding company — the full portfolio it is assembling across defense, autonomy and security.'}
      </p>

      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
        {holdings.map((h) => {
          const color = battery ? (BATTERY_TONE[h.type] ?? typeColor(h.type)) : typeColor(h.type)
          return (
            <div key={h.id} className="rounded-xl p-4 border" style={{ backgroundColor: 'var(--onds-surface)', borderColor: 'var(--onds-border)' }}>
              <div className="flex items-start justify-between gap-2 mb-2">
                <h3 className="font-bold leading-tight">{h.name}</h3>
                <span className="onds-chip shrink-0" style={{ color, borderColor: `${color}55`, backgroundColor: `${color}14` }}>
                  {h.type}
                </span>
              </div>
              {h.focus && <p className="text-sm text-[var(--onds-text-dim)] leading-relaxed mb-2">{h.focus}</p>}
              {h.rationale && (
                <p className="text-xs leading-relaxed mb-2" style={{ color: 'var(--onds-text)' }}>
                  <span className="font-semibold" style={{ color }}>Why it matters: </span>{h.rationale}
                </p>
              )}
              <div className="flex items-center gap-2 text-[11px] text-[var(--onds-text-dim)]">
                {h.status && (
                  <span className="flex items-center gap-1">
                    <BadgeCheck className="h-3.5 w-3.5" style={{ color }} />
                    {h.status}
                  </span>
                )}
                {h.date && <span>· {h.date}</span>}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
